import React from 'react';
import { TypewriterText } from '@/components/custom/typewriter-text';
import { cn } from '@/lib/utils';

function TiaBanner({ image, imageAlt = 'T.I.A', imageHeight = 180, imageOffset = 170, imageClassName, bubbleMaxWidth = 800, bubbleCorner = 'bl', bubbleIcon, text, decoration, className, background = 'var(--color-bg-lilac)' }) {
  return (
    <div
      className={cn('relative flex flex-col gap-3 rounded-[24px] p-4 shadow-card md:flex-row md:items-center md:pl-[var(--tia-offset)]', className)}
      style={{
        background,
        '--tia-offset': `${imageOffset}px`,
        '--tia-height': `${imageHeight}px`
      }}
    >
      {decoration}

      {/* Mobile: T.I.A + balão em linha (T.I.A 175px, balão flex-1); no md+ o
          wrapper vira `contents` e a T.I.A volta a ser absoluta ao lado (layout
          desktop original, inalterado). */}
      <div className="flex items-end gap-2 md:contents">
        <img
          src={image}
          alt={imageAlt}
          className={cn('pointer-events-none relative z-10 h-[175px] w-auto shrink-0 self-end object-contain object-bottom max-[374px]:h-[140px] md:absolute md:bottom-0 md:left-2 md:h-[var(--tia-height)]', imageClassName)}
        />

        <div
          className={cn('relative z-10 flex min-w-0 flex-1 items-start gap-3 rounded-[16px] bg-white p-4 shadow-card md:w-auto md:flex-initial md:p-5', bubbleCorner === 'bl' ? 'rounded-bl-none' : 'rounded-tl-none')}
          style={{ maxWidth: bubbleMaxWidth }}
        >
          <div>
            <p
              className="mb-0 whitespace-pre-line text-sm font-bold leading-relaxed"
              style={{ color: '#222731' }}
            >
              <TypewriterText text={text} />
            </p>
          </div>

          {bubbleIcon && (
            <img
              src={bubbleIcon}
              alt=""
              className="h-auto w-4 shrink-0"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export { TiaBanner };
